/* Decorates native cart nodes; native input order, controls and drawer ownership are retained. */
(function(root){
 'use strict';
 const P=root.NikuyaCartUIPresenter,doc=root.document;
 function clear(){
  const drawer=doc.getElementById('CartDrawer');if(!drawer)return;
  drawer.classList.remove('nky-branded-ready');
  drawer.querySelectorAll('[data-nky-decoration]').forEach(n=>n.remove());
  drawer.querySelectorAll('.nky-managed-line').forEach(n=>n.classList.remove('nky-managed-line'));
 }
 function apply(form,model){
  clear();if(form?.id!=='CartDrawer-Form'||!model?.snapshot)return;
  const nodes=[...form.querySelectorAll('.cart-item[data-key]')];
  if(nodes.length!==model.snapshot.items.length||nodes.some((n,i)=>n.dataset.key!==model.snapshot.items[i].key))return;
  const drawer=doc.getElementById('CartDrawer');drawer.classList.add('nky-ui','nky-branded','nky-branded-ready');
  for(const node of nodes){
   const gift=model.gifts?.[node.dataset.key];if(!gift)continue;
   const html=P.gift(gift,model.formatMoney);if(!html.includes('data-gift-state="included"'))continue;
   const wrap=doc.createElement('div');wrap.dataset.nkyDecoration='gift';wrap.innerHTML=html;
   node.classList.add('nky-managed-line');node.append(wrap);
  }
  const footer=drawer.querySelector('.drawer__footer'),wrap=doc.createElement('div');
  wrap.dataset.nkyDecoration='summary';wrap.innerHTML=P.summary(model.summary);
  wrap.querySelector('[data-ui-action="checkout"]')?.remove();footer.prepend(wrap);
  const rec=form.querySelector('[data-nikuya-cart-recommendations]');
  rec.innerHTML=P.recommendations(model.recommendations,model.scope,model.recommendationContext);rec.hidden=!rec.innerHTML;
 }
 root.NikuyaCartBranded=Object.freeze({apply,clear});
})(window);
